module.exports = __webpack_public_path__ + "2b92867fcf6d7ecf887d051b2b89d486.MP3";